export default __webpack_public_path__ + "JCB.6932bfcf.svg";